export const vars = {
  appName: 'Mag.O',
  asideWidth: '18.05rem',
}
